import { ROUTES, CB_ROUTES } from './routes';
import { APP_CODES } from './appcodes';

export const APPS = {
  BOT_BUILDER: {
    code: APP_CODES.BOT_BUILDER,
    group: ROUTES.CONVERATION_BUILDER,
    path: CB_ROUTES.BOT_BUILDER,
  },
  INTENT_MANAGER: {
    code: APP_CODES.INTENT_MANAGER,
    group: ROUTES.INTENT_MANAGER,
  },
  KNOWLEDGE_BASE: {
    code: APP_CODES.KNOWLEDGE_BASE,
    group: ROUTES.CONVERATION_BUILDER,
    path: CB_ROUTES.KNOWLEDGE_BASE,
  },
  ANALYTICS: {
    code: APP_CODES.ANALYTICS,
    group: ROUTES.CONVERATION_BUILDER,
    path: CB_ROUTES.ANALYTICS,
  },
  SYS_ADMIN: {
    code: APP_CODES.SYS_ADMIN,
    group: ROUTES.CONVERATION_BUILDER,
    path: CB_ROUTES.SYS_ADMIN,
  },
  ORG_MGMT: {
    code: APP_CODES.ORG_MGMT,
    group: ROUTES.CONVERATION_BUILDER,
    path: CB_ROUTES.ORG_MGMT,
  },
  MAVEN: {
    code: APP_CODES.MAVEN,
  },
  BOT_PLATFORM: {
    code: APP_CODES.BOT_PLATFORM,
    group: ROUTES.BOT_PLATFORM,
  },
  CONVERSATION_ASSIST: {
    code: APP_CODES.CONVERSATION_ASSIST,
    group: ROUTES.CONVERSATION_ASSIST,
  },
  PERFORMANCE_OPTIMIZER: {
    code: APP_CODES.PERFORMANCE_OPTIMIZER,
    group: ROUTES.PERFORMANCE_OPTIMIZER,
    path: ROUTES.PERFORMANCE_OPTIMIZER,
  },
  DATA_TRANSPORTER: {
    code: APP_CODES.DATA_TRANSPORTER,
    group: ROUTES.DATA_TRANSPORTER,
    path: ROUTES.DATA_TRANSPORTER,
  },
  AIWB: {
    code: APP_CODES.AIWB,
    group: ROUTES.AIWB,
    path: ROUTES.AIWB,
  },
};

export default APPS;
